import * as React from "react";
export var IconButtonContext = React.createContext({
    edge: false,
});
export var useIconButtonContext = function () { return React.useContext(IconButtonContext); };
